import { platformSwitch } from '../configuration';

import web from './web';
import native from './native';

export default platformSwitch({
  web,
  native,
});
